import { Controller } from '@hotwired/stimulus';

// Drives the "create template" single-form flow. Picking a type card swaps the
// form action + category, shows the matching section (and disables the hidden
// ones' inputs so they neither submit nor block validation), and updates the
// callout, title placeholder and submit button.
export default class extends Controller {
  static targets = [
    'card',
    'form',
    'category',
    'callout',
    'section',
    'icon',
    'titleInput',
    'submitLabel',
  ];

  static values = {
    type: String,
    urls: Object,
    placeholders: Object,
    labels: Object,
  };

  connect() {
    this.fillTitleFromFile = this.fillTitleFromFile.bind(this);
    this.fileInput = this.element.querySelector('input[type="file"]');
    if (this.fileInput) {
      this.fileInput.addEventListener('change', this.fillTitleFromFile);
    }
  }

  disconnect() {
    if (this.fileInput) {
      this.fileInput.removeEventListener('change', this.fillTitleFromFile);
    }
  }

  select(event) {
    this.typeValue = event.currentTarget.dataset.type;
  }

  // Pre-fill the (still empty) title from the chosen PDF filename, replacing the
  // old jQuery helper.
  fillTitleFromFile(event) {
    const file = event.target.files && event.target.files[0];
    if (!file || !this.hasTitleInputTarget) return;
    if (this.titleInputTarget.value.trim() !== '') return;

    this.titleInputTarget.value = file.name.replace(/\.[^/.]+$/, '');
  }

  typeValueChanged() {
    this.apply();
  }

  apply() {
    const type = this.typeValue;

    this.cardTargets.forEach((card) => {
      const selected = card.dataset.type === type;
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', String(selected));
    });

    if (this.hasFormTarget && this.urlsValue[type]) {
      this.formTarget.action = this.urlsValue[type];
    }
    if (this.hasCategoryTarget) this.categoryTarget.value = type;

    this.sectionTargets.forEach((section) => {
      this.toggleSection(section, section.dataset.type === type);
    });

    this.calloutTargets.forEach((callout) => {
      callout.hidden = callout.dataset.type !== type;
    });

    this.iconTargets.forEach((icon) => {
      icon.hidden = icon.dataset.type !== type;
    });

    if (this.hasTitleInputTarget && this.placeholdersValue[type]) {
      this.titleInputTarget.placeholder = this.placeholdersValue[type];
    }

    if (this.hasSubmitLabelTarget && this.labelsValue[type]) {
      this.submitLabelTarget.textContent = this.labelsValue[type];
    }
  }

  // Show/hide a section and enable/disable its fields so only the active
  // section participates in submission and HTML validation.
  toggleSection(section, active) {
    section.hidden = !active;
    section.querySelectorAll('input, select, textarea').forEach((field) => {
      field.disabled = !active;
    });
  }
}
